








































































import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import CallVerification from "@/consoleapi/api/call_verification";

@Component
export default class VerificationCode extends Vue {
    @Prop() public phoneNumber!: string;
    @Prop() public requestId!: string;

    private code = '';
    private service = 'MypagePhoneVerification';
    private accountSid = '';

    @Emit()
    public inputConfirmEmit(inputConfirm: boolean) {
        inputConfirm;
    }

    verification() {
        const callVerification = new CallVerification();
        callVerification.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
        callVerification.verify(
            this.$cookies.get(String(process.env.VUE_APP_COOKIE_COGNITO_USER_NAME)),
            this.service,
            this.requestId,
            this.code,
            this.phoneNumber,
            this.accountSid
        ).then(response => {
            // console.log(response.data);
            this.$router.push('/register/credit');
        }).catch(error => {
            alert('認証コードが誤っているか、期限が切れています。再度発信を行い、認証コードをご確認ください。');
            this.inputConfirmEmit(false);
        })
    }

    retry() {
        this.inputConfirmEmit(false);
    }
}
